const $ = require('jquery');
import HashFragmentParams from '../../new-car-pages/modules/hash-fragment-params';
import NewSearchForm from '../search/motability-search-form';
import bindCompareEvent from '../../modules/bindCompareEvent';
import tagging from './tagging';

const hashFragmentParams = new HashFragmentParams();
const newSearchForm = new NewSearchForm(hashFragmentParams, {
    mobileFormElement: document.getElementById('motability-search-form'),
    desktopFormElement: document.getElementById('motability-search-form'),
});
const searchResultsEl = document.getElementById('search-results');
const resultsContainerEl = document.querySelector('.results');

$('#motability-search-form').submit(function(e) {
    e.preventDefault();
    newSearchForm.updateUrl();
});

const advancedSearchButton = document.getElementById('advanced-search-options-btn');
const advancedSearchArea = document.getElementById('advanced-search-options');
if (advancedSearchArea && advancedSearchButton) {
    let advancedSearchAreaShown = false;
    advancedSearchButton.addEventListener('click', function() {
        advancedSearchArea.style.display = (advancedSearchAreaShown) ? 'none' : 'block';
        advancedSearchAreaShown = !advancedSearchAreaShown;
    });
}

// Get the URL for the current search page e.g. /peugeot/new/search
const searchURLElement = document.getElementById('search-url');
const searchURL = searchURLElement.value;
// Polyfill for .remove();
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
searchURLElement.remove();

window.addEventListener('paramchange', event => {
    // $('.search-results-row').removeClass('bounceInUp').addClass('bounceOutUp');

    const timeout = setTimeout(function() {
        const loadingDiv = document.createElement('div');
        loadingDiv.classList.add('loading');
        const loadingImg = document.createElement('img');
        loadingImg.src = '/images/shared/Robins-And-Day-Loader.svg';
        loadingImg.alt = 'Loading Results';
        searchResultsEl.appendChild(loadingDiv.appendChild(loadingImg));
    }, 300);


    $.ajax({
        async: true,
        type: "POST",
        cache: false,
        dataType: 'html',
        url: searchURL,
        data: event.detail.params,
        sourceData: event.detail.params,
        hash: event.detail.hash,
        success: function(response) {
            if (this.hash != hashFragmentParams.hashSignature) {
                return;
            }
            clearTimeout(timeout);
            searchResultsEl.innerHTML = response;

            bindCompareEvent('[data-compare]');

            // Hide the pagination whilst we convert the URLs to hash fragment navigation rather than full query string ($_GET) navigation
            $('.pagination').addClass('pagination--hidden');
            $('.pagination a').each(function(i, el) {
                let href = el.getAttribute('href');
                if (href.indexOf('?') > 0) {
                    href = href.split('?');
                    href = '#' + ((typeof href[1] !== 'undefined') ? href[1] : '');
                }
                el.setAttribute('href', href);
            });
            $('.pagination').removeClass('pagination--hidden');

            $('[data-pagination-button]').each(function(i, el) {
                let href = el.getAttribute('href');
                if (href.indexOf('?') > 0) {
                    href = href.split('?');
                    href = '#' + ((typeof href[1] !== 'undefined') ? href[1] : '');
                }
                el.setAttribute('href', href);
            });

            if (brand != 'fiat' && $('.toggle--checked').length) {
                $('[data-prices]').toggleClass('results__prices--hidden')
            }
        },
        error: response => {
            console.error(response);
        }
    });
}, false);

$('[data-resets-form]').on('click.newSearchForm', () => {
    newSearchForm.resetForm()
})

// Set the initial values for the form elements, since all the inputs will load unchecked/blank.
if (options) {
    newSearchForm.loadFromParams({...hashFragmentParams.params, ...options});
} else {
    newSearchForm.loadFromParams(options);
}

// Init the search form, which when completed will trigger the first load of the results too
newSearchForm.formUpdated('init', null)

$('.results').on('click', '[data-pagination-next], .pagination a', () => {
    const top = resultsContainerEl.getBoundingClientRect().top;

    $('html, body').animate({
        scrollTop: top - 30,
    }, 350);
});

$('[data-add-page-scroll]').on('click', () => {
    $('body').toggleClass('disable-scroll');
});

$('#modelDropdown').on('change', ({ target }) => {
    const option = target.options[target.selectedIndex];

    if (!option.dataset.newModelId) {
        return;
    }

    if (!pages) {
        return;
    }

    const page = pages.find(page => page.new_model_id == option.dataset.newModelId);

    if (!page) {
        return;
    }

    if (document.querySelector('[data-title]')) {
        document.querySelector('[data-title]').innerText = page.title;
    }

    if (document.querySelector('[data-content]')) {
        document.querySelector('[data-content]').innerHTML = page.content;
    }

    history.pushState('', '', page.url);
});

tagging();

$('[data-toggles-quote-type]').on('click', () => {
    if (brand == 'fiat') {
        return;
    }
    $('[data-quote-toggle]')
        .toggleClass('toggle--checked')
        .find('[data-quote-type]')
        .not(':checked')
        .prop('checked', true)

    $('[data-prices]').toggleClass('results__prices--hidden')

    newSearchForm.formUpdated('', null);
})

$('[data-quote-type]').on('change', () => {
    if (brand == 'fiat') {
        return;
    }
    $('[data-quote-toggle]').toggleClass('toggle--checked')
    $('[data-prices]').toggleClass('results__prices--hidden')

    newSearchForm.formUpdated('', null);
})

$('[data-toggles-search]').on('click', function() {
    $('body').toggleClass('disable-scroll')
    $('#refine-search-overlay').toggleClass('hidden')
    $('#motability-search-form').toggleClass('refine-search--open')
})

$('#sort-element').on('change', function() {
    $('#sort').val($(this).val())
    $('#motability-search-form').submit()
})

$('[data-opens-dropdown]').on('click', function() {
    $($(this).data('opens-dropdown')).toggleClass('filter__dropdown--open')
})

$('[data-sort-by]').on('click', function() {
    $('#sort').val($(this).data('sort-by'))
    $('#motability-search-form').submit()
})